import React from "react";
import { CardItem, CardItemProps } from "./CardItem";

interface CardGridSectionProps {
    cardItems: CardItemProps[]
}
export const CardGridSection: React.FC<CardGridSectionProps> = ({ cardItems }) => {
    return (
        <section className="grid grid-cols-1 xl:grid-cols-3 w-full container mx-auto gap-[32px] pb-96">
            {cardItems?.map((card, index) => (
                <CardItem key={index} {...card} index={index} />
            ))}
        </section>
    );
};
